import React from 'react';
import styles from './index.module.scss';
import { EnhanceSelect, InSingleOption } from '@lingxi-common-component/sirius-ui/Select';
const TimeZoneSelect = ({ onChange, timeZone, timeZoneList }) => {
    const handleTimeZoneChange = (val) => {
        onChange && onChange(val);
    };
    return (React.createElement("div", { className: styles.timeZoneSelect },
        React.createElement(EnhanceSelect, { defaultValue: 8, value: timeZone, onChange: handleTimeZoneChange, style: { width: 228, height: 32, marginRight: 8 } }, timeZoneList.map(({ key, value }) => (React.createElement(InSingleOption, { value: key, key: key }, value))))));
};
export default TimeZoneSelect;
